<div class="flex min-h-screen flex-col gap-6 p-6 pt-2">
  @if (errorBundleData() && !loadingBundleData()) {
    <app-error-data [title]="errorBundleData()!" />
  }

  @if (bundleData() && !loadingBundleData()) {
    <h1 class="offerTitle text-[32px] leading-tight font-[700]">
      {{ isArabic() ? bundleData()?.titleAr || "غير متوفر" : bundleData()?.titleEn || "Not Provided" }}
    </h1>
    <div class="flex w-full items-center justify-center gap-8 rounded-[16px] p-6 pt-2">
      <app-image-carousel type="offer" [profileImage]="bundleImageUrl()" [isLoading]="loadingBundleData()" />
    </div>
  } @else if (loadingBundleData()) {
    <app-loading />
  }

  @if (!errorBundleData() && !loadingBundleData()) {
    <div class="border-b border-gray-200">
      <nav class="flex gap-4">
        <button
          (click)="setActiveTab('details')"
          [ngClass]="
            activeTab() === 'details' ? 'borderTabsColor textTabsColor border-b-2' : 'border-transparent text-gray-500'
          "
          class="cursor-pointer pb-2 text-[14px] font-medium">
          {{ isArabic() ? "تفاصيل الباقة" : "Bundle Details" }}
        </button>
        <button
          (click)="setActiveTab('products')"
          [ngClass]="
            activeTab() === 'products' ? 'borderTabsColor textTabsColor border-b-2' : 'border-transparent text-gray-500'
          "
          class="cursor-pointer pb-2 text-[14px] font-medium">
          {{ isArabic() ? "الأصناف المدرجة" : "Products Included" }}
        </button>
      </nav>
    </div>

    <div>
      @if (activeTab() === "details") {
        <app-bundle-details-tab [bundle]="bundleData()!" />
      } @else if (activeTab() === "products") {
        <app-bundle-included-items-tab [bundleId]="bundleData()!.id.toString()" />
      }
    </div>
  }
</div>
